module.exports = __webpack_public_path__ + "img/root1.de7a1b44.png";